module.exports = __webpack_public_path__ + "static/media/info.73c604fc.svg";